import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { deletePayMethodDataApi } from "src/Api/Services/SystemConfiguration";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSnackbar } from "notistack5";
import useCustomConfirmSnackBar from "src/components/CustomComponents/useCustomConfirmSnackBar";
const PaymentMethodTable = ({ data, fetchData, editClick }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const showConfirmAlert = useCustomConfirmSnackBar();
  const { enqueueSnackbar } = useSnackbar();
  const hadndleDelete = async (id) => {
    try {
      const { data } = await deletePayMethodDataApi(id);
      data.status && fetchData();
      enqueueSnackbar(data.message, {
        variant: data.status ? "success" : "error",
      });
    } catch (error) {
    } finally {
    }
  };
  return (
    <TableContainer
      className="tableairp-responsive"
      style={{ maxHeight: "none", height: "100%", marginTop: "20px" }}
    >
      <Table className="table-airp">
        <TableHead>
          <TableRow className="laststick-tr">
            {TableHeaderName.map((item, index) => (
              <TableCell key={index}>{item}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {data
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((item, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.metaKey}</TableCell>
                <TableCell>{item.upiDiscount}</TableCell>
                <TableCell>{item.creditCardDiscount}</TableCell>
                <TableCell>{item.debitCardDiscount}</TableCell>
                <TableCell>{item.netBankingDiscount}</TableCell>
                <TableCell>{item.payLaterDiscount}</TableCell>
                <TableCell>{item.walletDiscount}</TableCell>
                <TableCell>
                  <div className="d-flex">
                    <div className="me-2">
                      <IconButton
                        aria-label="edit"
                        color="success"
                        onClick={() => editClick(item)}
                      >
                        <EditIcon />
                      </IconButton>
                    </div>
                    <div>
                      {" "}
                      <IconButton
                        aria-label="delete"
                        color="error"
                        onClick={() =>
                          showConfirmAlert("Are you sure?", "warning", () =>
                            hadndleDelete(item._id)
                          )
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, page) => setPage(page)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(+e.target.value);
          setPage(0);
        }}
      />
    </TableContainer>
  );
};

export default PaymentMethodTable;
const TableHeaderName = [
  "S.No.",
  "Meta Key",
  "UPI Discount",
  "Credit Card Discount",
  "Debit Card Discount",
  "Net Banking Discount",
  "Pay later Discount",
  "Wallet Discount",
  "Action",
];
